<input
  #fileInput
  type="file"
  accept="image/*"
  style="display: none"
  (change)="onUpload()"
/>

<app-modal
  #deleteProfilePhotoModal
  [modalTitle]="app.text.app.confirm"
  [modalMessage]="app.text.app.deleteProfilePicture"
  (ok)="onDelete()"
>
</app-modal>

<app-modal
  #discardChangesModal
  [modalMessage]="app.text.profile.discard"
  [modalTitle]="app.text.profile.modalTitle"
  (ok)="discardDetails()"
>
</app-modal>
<div class="row col-md-12"  *ngIf="!app.profile.viewProfile">
  <div class="col-xl-4 col-md-12 col-sm-12 pictureSection">
    <div class="my-3">
      <div class="col-md-12">
        <div class="legend">{{ app.text.profile.profileImg }}</div>
      </div>
      <div *ngIf="name != null">
        <div class="text-center">
          <img
            *ngIf="app.profile.userProfilePicture != ''"
            class="userImage"
            target="_blank"
            [src]="app.file.getUrl(app.profile.userProfilePicture)"
          />
          <img
            *ngIf="app.profile.userProfilePicture === ''"
            class="userImage"
            target="_blank"
            [src]="app.url.profile.defaultImage"
          />

          <div class="deteleIcons">
            <button
              *ngIf="
                own &&
                app.profile.userProfilePicture === '' &&
                checkPermissions(name)
              "
              class="btn btn-sm btn-image"
              (click)="fileInput.click()"
              [title]="app.text.profile.uploadImage"
              [disabled]="app.unlockedId != null"
            >
              <i class="fa fa-upload"></i>
            </button>

            <button
              *ngIf="
                own &&
                app.profile.userProfilePicture !== '' &&
                checkPermissions(name) &&
                app.unlockedId == null
              "
              class="btn btn-sm btn-image"
              (click)="deleteProfilePhotoModal.open()"
              [title]="app.text.profile.deleteImage"
              [disabled]="app.unlockedId != null"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="text-center name">
          {{ fullName }}
        </div>
      </div>
      <div class="col-md-12">
        <div *ngIf="own && app.unlockedId === null">
          <div class="legend">
            {{ app.text.profilePassword.passwordChange }}
          </div>
          <app-password></app-password>
        </div>
      </div>

      <!-- Security -->
      <div class="col-md-12">
        <div *ngIf="own && app.unlockedId === null">
          <div class="legend">{{ app.text.userSettings.security }}</div>
          <div
            class="col-md-12"
            *ngIf="
              name === app.user &&
              app.userSettings.userSettings.mfaPreferences
            "
          >
            <div class="m-2">
              <div class="m-2 d-flex align-items-center">
                <button
                  class="btn"
                  (click)="app.userSettings.setMFAPreferences()"
                  [disabled]="app.profile.canEdit2FAForUser()"
                >
                  <i
                    *ngIf="app.userSettings.userSettings.mfaPreferences.email"
                    class="fa fa-toggle-on check-on"
                  ></i>
                  <i
                    *ngIf="!app.userSettings.userSettings.mfaPreferences.email"
                    class="fa fa-toggle-off check-off"
                  ></i>
                </button>
                <label class="fieldNameC">{{
                  app.text.userSettings.MFAEmail
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Language Change  -->
      <div *ngIf="app.customer !== 'oc'">
        <div *ngIf="own && app.unlockedId === null">
          <div class="legend">{{ app.text.profile.language }}</div>
          <div
            class="languages-container m-4"
            *ngIf="name === app.user"
          >
            <div class="btn-group" *ngFor="let language of app.languages">
              <button
                *ngIf="app.customer !== 'ns' && language !== 'nl'"
                class="btn btn-sm language-btn"
                [ngClass]="{ 'selected-language': language === app.language }"
                (click)="
                  app.language = language; app.users.setLanguage(language)
                "
              >
                {{ language | uppercase }}
              </button>
              <button
                *ngIf="app.customer === 'ns'"
                class="btn btn-sm language-btn"
                [ngClass]="{ 'selected-language': language === app.language }"
                (click)="
                  app.language = language; app.users.setLanguage(language)
                "
              >
                {{ language | uppercase }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-7 col-md-12 col-sm-12 detailSection">
    <div class="pb-2 my-3">
      <div class="col-md-12">
        <div class="legend">{{ app.text.profile.profileInfo }}</div>
      </div>
      <div class="row p-2">
        <div class="pull-right">
          <div class="controls">
            <app-unlock [id]="name" [permission]="checkPermissions(name)">
              <button
                class="btn btn-sm btn-clean"
                [title]="app.text.profile.close"
                (click)="dismissModal()"
              >
                <i class="fas fa-times close-icon"></i>&nbsp;
                {{ app.text.post.cancel }}
              </button>
            </app-unlock>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-field
            *ngFor="let field of personProfileFields; index as index"
            [model]="app.profile.profileWithSections"
            [field]="field"
            [index]="index"
            [publicFieldName]="app.fieldId.personProfile.publicFields"
            [disabled]="app.isLocked(name)"
            [noStriped]="true"
            [shadowInput]="true"
          >
          </app-field>
        </div>
        <div class="col-6">
          <app-field
            *ngFor="
              let field of app.list.organizationProfile.organizationProfile;
              index as index
            "
            [model]="app.profile.profileWithSections"
            [field]="field"
            [index]="index"
            [publicFieldName]="app.fieldId.organizationProfile.publicFields"
            [disabled]="app.isLocked(name)"
            [noStriped]="true"
            [shadowInput]="true"
          >
          </app-field>
        </div>
      </div>
      <div class="row centeredRow mt-5">
        <div
          class="col-md-6 text-center saveBtn"
          (click)="app.profile.updateProfile(); app.unlockedId = null"
          *ngIf="app.unlockedId != null"
        >
          <button class="saveBtn" [disabled]="!modelHasChanges()">
            {{ app.text.user.edit }}
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="showEmailsBox()">
      <div class="pb-2 my-3" *ngIf="app.unlockedId == null">
        <div class="col-md-12">
          <div class="legend">
            {{ app.text.userSettings.emailPreferences }}
          </div>
        </div>
        <!-- //Settings -->
        <div class="row">
          <div class="col-md-12">
            <app-user-settings></app-user-settings>
          </div>
        </div>
      </div>
    </div>

    <!-- Badge system -->
    <div *ngIf="app.customer === 'oc'">
      <div class="pb-2 my-3">
        <div class="legend">My Badges</div>
        <div *ngFor="let badge of app.OCHome.badges" class="m-2">
          <i class="fa-solid fa-medal fa-fw" [style.color]="badge.color"></i>
          <span class="label"> {{ badge.text.en }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- If current view is view mode only -->
<div class="row fixed" *ngIf="app.profile.viewProfile">
  <div class="col-md-12">
    <div class="d-flex">
      <button
        class="btn btn-control me-auto p-2"
        (click)="app.profile.viewProfile = false"
      >
        <i class="far fa-times"></i> &nbsp; {{ app.text.user.closeWindow }}
      </button>
    </div>
  </div>
  <div class="col-md-12">
    <div class="col profilePicture">
      <div *ngIf="name != null">
        <div class="text-center">
          <img
            *ngIf="app.profile.userProfilePicture != ''"
            class="userImage"
            target="_blank"
            [src]="app.file.getUrl(app.profile.userProfilePicture)"
          />
          <img
            *ngIf="app.profile.userProfilePicture === ''"
            class="userImage"
            target="_blank"
            [src]="app.url.profile.defaultImage"
          />
        </div>
        <div class="text-center my-2 name">
          {{ app.profile.selectedProfile }}
        </div>
        <div
          class="text-center my-2 disabledName"
          *ngIf="app.profile.profileNotFound"
        >
          *Profile deleted*
        </div>
      </div>
    </div>
    <div class="legend m-4">{{ app.text.profile.profileInfo }}</div>
    <div class="m-4 mb-0">
      <div
        div
        class="col-md-2 form-group"
        *ngFor="let field of personProfileFields; let i = index"
      >
        <label class="font-size-12" for="name">{{
          app.field.getLabel(field)
        }}</label>
        <div
          class="value"
          *ngIf="app.profile.profileWithSections[field] !== ''"
        >
          {{ app.profile.profileWithSections[field] }}
        </div>
        <div class="value" *ngIf="app.profile.profileWithSections[field] == ''">
          --
        </div>
      </div>
    </div>
    <div class="m-4 mt-0">
      <div
        class="col-md-2 form-group"
        *ngFor="
          let field of app.list.organizationProfile.organizationProfile;
          let j = index
        "
      >
        <label class="font-size-12" for="name">{{
          app.field.getLabel(field)
        }}</label>
        <div
          class="value"
          *ngIf="app.profile.profileWithSections[field] !== ''"
        >
          {{ app.profile.profileWithSections[field] }}
        </div>
        <!-- <div
          class="value"
          *ngIf="
            app.profile.profileWithSections[field] == '' ||
            app.profile.profile.data === null || app.profile.data === ''
          "
        >
          --
        </div> -->
      </div>
    </div>
  </div>
</div>
